import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {
  public temp_var: boolean = false;
  public message = [];
  modalRef: any;
  getmessage: any;
  resepon: any;
  currentUser: User;
  tempmsg: any;
  public patient: any;

  public msg: any = {};
  apiurl: any = environment.api_url;
  dtOptions: any = {};
  public imageURL: string = environment.cloudeImageURL;
  dateForm = environment.dateForm;

  constructor(
    private patientservice: PatientService,
    private userService: UserService,
    private modalService: BsModalService,
    private router: Router,
    private toastr: ToastrService,
    private Datepipe: DatePipe,
  ) { }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item.hostModel == "CLOUD")
          this.imageURL = environment.cloudeImageURL;
        else
          this.imageURL = environment.vmImageURL;
      }
    )



    this.dtOptions = {
      // Configure the pagelength
      pageLength: 10,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      dom: 'Blfrtip',
      buttons: [
        {
          extend: 'excelHtml5',
          text: 'Download Excel',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },
        {
          extend: 'pdfHtml5',
          orientation: 'landscape',
          text: 'Download PDF',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },

      ]
    };
    this.patientservice
      .getpatientmessage()
      .subscribe(
        data => {
          //////console.log(data);
          this.temp_var = true;
          this.message = data;
        }
      );


  }
  getTitle() {
    return `Messages List`
  }
  openModal(template: TemplateRef<any>, emp) {

    this.modalRef = this.modalService.show(template, { backdrop: true, ignoreBackdropClick: true, });
    this.movable()
    this.tempmsg = emp;
    this.msg.desp = '';
    this.userService.getmessagedetails(this.tempmsg.patientSWFId).subscribe(
      data => {
        console.log("message", data);
        this.getmessage = data;
      }
    );
  }

  /*closetemp(){
  
  this.patientservice
  .getpatientmessage()
  .subscribe(
    data => 
    {
      this.temp_var = true;
      this.message = data;
    }      
  );
  
    this.modalRef.hide();
  }*/

  reset() {
    this.modalRef.hide()
    this.temp_var = false;
    this.patientservice
      .getpatientmessage()
      .subscribe(
        data => {
          //////console.log(data);
          this.temp_var = true;
          this.message = data;
        }
      );

  }

  saveMessage(msg) {
    //////console.log(msg.value);
    let msgvalue = {
      "patientSWFId": this.tempmsg.patientSWFId,
      "patientId": this.tempmsg.patientId,
      "description": msg.value.desp
    }
    //////console.log(msgvalue);
    this.userService
      .sendsms(msgvalue)
      .subscribe(
        data => {

          if (data.status = "Success") {
            this.toastr.toastrConfig.timeOut = 3000;

            this.userService.logAudit("createNewMessage", 0).subscribe(data => { })

            this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.msg_sent.success'));


            this.userService
              .getmessagedetails(this.tempmsg.patientSWFId)
              .subscribe(
                data => {

                  this.getmessage = data;
                  this.msg.desp = '';

                }
              );


          }
          else {
            this.toastr.success("Message not sent");

          }
        }
      );

  }
  // getdate(date) {
  //   if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
  //     return this.Datepipe.transform(date, environment.dateForm);
  //   }
  //   else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
  //     return this.Datepipe.transform(date, 'dd/MM/yyyy');
  //   }
  // }
  // getdatetime(date) {
  //   if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
  //     return this.Datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
  //   }
  //   else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
  //     return this.Datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
  //   }
  // }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
}